import { render, staticRenderFns } from "./RELUsuariosPassageiros.vue?vue&type=template&id=674f89b1&"
import script from "./RELUsuariosPassageiros.vue?vue&type=script&lang=js&"
export * from "./RELUsuariosPassageiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports